import React, { useState } from "react";
import { Button } from "../../ui";
import { FormControlLabel, Checkbox } from "@mui/material";
import useMobile from "../../hooks/useOrientation";
import { warning } from "../../ui/colors";
import Second from "./steps/Second";
import Third from "./steps/Third";
import { CircularProgress } from "@mui/material";
import { database } from "../../config";
import { addDoc, collection } from "firebase/firestore";

const AlbumScreen = () => {
  const [step, setStep] = useState(1);
  const isMobile = useMobile();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [albumData, setAlbumData] = useState({
    Nombre_Padres: "",
    Apellido_Padres: "",
    Telefono_Padres: "",
    Nombre_Pasajero: "",
    Apellido_Pasajero: "",
    Cedula_Pasajero: "",
    Numero_Bus: "",
  });
  const [alsoWantHoodie, setAlsoWantHoodie] = useState(false);

  const moveForward = async () => {
    setErrorMessage("");
    if (step === 1) {
      const {
        Nombre_Padres,
        Apellido_Padres,
        Telefono_Padres,
        Nombre_Pasajero,
        Apellido_Pasajero,
        Cedula_Pasajero,
        Numero_Bus,
      } = albumData;
      if (
        stringNotEmpty(Nombre_Padres) &&
        stringNotEmpty(Apellido_Padres) &&
        stringNotEmpty(Telefono_Padres) &&
        stringNotEmpty(Nombre_Pasajero) &&
        stringNotEmpty(Apellido_Pasajero) &&
        stringNotEmpty(Cedula_Pasajero) &&
        stringNotEmpty(Numero_Bus)
      ) {
        setErrorMessage("");
        setLoading(true);
        setStep(step + 1);
        await addDoc(collection(database, "album2026"), albumData);
        if (alsoWantHoodie) {
          await addDoc(collection(database, "buzo2026"), albumData);
        }
      } else {
        setErrorMessage("Se deben completar todos los campos.");
      }
    } else {
      setStep(step + 1);
    }
  };

  const stringNotEmpty = (word) => {
    return word;
  };

  const getComponentStep = () => {
    switch (step) {
      case 1:
        return (
          <Second
            data={albumData}
            onChangeData={(data) => setAlbumData(data)}
          />
        );
      case 2:
        return <Third />;
      default:
    }
  };

  const isLastStep = step === 2;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <h2 style={{ textAlign: "center", marginTop: 16 }}>Reservá tu álbum!</h2>
      <div
        style={{
          width: "100%",
        }}
      >
        {getComponentStep()}
        {step === 1 && (
          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 16 }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={alsoWantHoodie}
                  onChange={(e) => setAlsoWantHoodie(e.target.checked)}
                  color="primary"
                />
              }
              label="También quiero mi buzo"
            />
          </div>
        )}
      </div>
      {step === 1 && (
        <h4 style={{ color: warning, alignSelf: "center" }}>{errorMessage}</h4>
      )}
      <div
        style={{
          alignSelf: "center",
          textAlign: "center",
          padding: 10,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          {!isLastStep ? (
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
              >
                <Button
                  customStyles={{
                    margin: 5,
                    alignSelf: isMobile ? "center" : null,
                  }}
                  variant="contained"
                  onClick={moveForward}
                >
                  <h3 style={{ margin: 0 }}>Terminar</h3>
                </Button>
              </div>
              {loading ? <CircularProgress /> : null}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AlbumScreen;
